import { createSlice } from '@reduxjs/toolkit';

import { State } from './types';

export const initialState: State = {
  activeModal: null,
};

export default createSlice({
  name: 'savedDashboards',
  initialState,
  selectors: {
    selectActiveModal: (state: State) => state.activeModal,
  },
  reducers: {
    setActiveModal: (state, action) => {
      state.activeModal = {
        selectedDashboard: action.payload.dashboard,
        name: action.payload.name,
      };
    },
    closeActiveModal: (state) => {
      state.activeModal = null;
    },

    reset: () => {
      return {
        ...initialState,
      };
    },
  },
});
